import { render } from "./MyPageInfoChange_joinM.vue?vue&type=template&id=860b2c88&scoped=true"
import script from "./MyPageInfoChange_joinM.vue?vue&type=script&lang=js"
export * from "./MyPageInfoChange_joinM.vue?vue&type=script&lang=js"

import "./MyPageInfoChange_joinM.vue?vue&type=style&index=0&id=860b2c88&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-860b2c88"]])

export default __exports__